import { studentInterface as Student } from "@/models";
import { v4 } from "uuid";

export const StudentsMock: Student[] = [
  {
    id: v4(),
    firstName: 'John',
    lastName: 'Doe',
  },
  {
    id: v4(),
    firstName: 'Jane',
    lastName: 'Doe',
  },
  {
    id: v4(),
    firstName: 'Alice',
    lastName: 'Smith',
  },
  {
    id: v4(),
    firstName: 'Bob',
    lastName: 'Smith',
  }
];
export default StudentsMock;